import React from "react";

function insertMarkup(x) {
  return <div dangerouslySetInnerHTML={{__html: x}} /> ;
}

export default insertMarkup;